/**
 * Survey question options for user research during registration
 */

export interface SurveyOption {
  value: string
  label: string
}

// Step 1: Who is this workspace for? → stored in survey_user_role
export const USER_ROLE_OPTIONS: SurveyOption[] = [
  { value: 'solo_founder', label: 'My Startup' },
  { value: 'corporate_pm', label: 'My Company / Team' },
  { value: 'agency_strategy', label: 'My Clients' },
  { value: 'incubator_accelerator', label: 'A Portfolio of Founders' },
]

// Step 2: Where is your current project at? → stored in survey_ideation_frequency
export const PROJECT_STAGE_OPTIONS: SurveyOption[] = [
  { value: 'just_idea', label: 'Just an idea' },
  { value: 'in_the_weeds', label: 'In the weeds' },
  { value: 'feature_factory', label: 'Pushing back on feature requests' },
  { value: 'post_launch', label: 'Post-launch troubleshooting' },
]

// Step 3: What would make today a win? → stored in survey_use_cases (max 2 selections)
export const SESSION_GOAL_OPTIONS: SurveyOption[] = [
  { value: 'structured_map', label: 'Mapping my messy ideas' },
  { value: 'mom_test_survey', label: 'Generating a survey to send today' },
  { value: 'hard_data', label: 'Getting hard data to score an idea' },
  { value: 'storyboard', label: 'Creating a storyboard for my team' },
]

/** @deprecated No longer collected in the survey */
export const CURRENT_TOOLS_OPTIONS: SurveyOption[] = [
  { value: 'chatgpt', label: 'ChatGPT' },
  { value: 'miro', label: 'Miro' },
  { value: 'figjam', label: 'FigJam' },
  { value: 'notion', label: 'Notion' },
  { value: 'whiteboard', label: 'Whiteboard' },
  { value: 'nothing_structured', label: 'Nothing structured' },
  { value: 'other', label: 'Other' },
]

// Helper to get label from value — falls back to raw value if not found
export function getSurveyOptionLabel(options: SurveyOption[], value: string): string {
  return options.find((opt) => opt.value === value)?.label ?? value
}

// Helper to get labels from values array
export function getSurveyOptionLabels(options: SurveyOption[], values: string[]): string[] {
  return values.map((v) => getSurveyOptionLabel(options, v))
}
